<template>
    <div>
        <div class="modal" :class="{ 'open': open }" v-if="open">
            <div class="modal-base ff-reg fs-22">
                <div class="modal-base-header">
                    <!-- <div id="otp_close" class="ic-close" @click="cancelOtp()">
                        <img src="../../../assets/ic_close.svg" />
                    </div> -->
                    <p id="otp_header" class="otp-txt">{{ lblOtp.headline }}</p>
                </div>
                <div class="modal-base-body">
                    <div class="otp-txt" v-html="contact_number_msg"></div>
                    <!-- <div class="otp-txt">Ref Code : 33H1T</div> -->
                    <label id="otp_box_wrapper" for="input-otp">
                        <div class="d-flex justify-content-center ff-med">
                            <div class="box-input-otp" :class="{ 'box-input-otp-filled': otp[0] }">{{ otp[0] }}</div>
                            <div class="box-input-otp" :class="{ 'box-input-otp-filled': otp[1] }">{{ otp[1] }}</div>
                            <div class="box-input-otp" :class="{ 'box-input-otp-filled': otp[2] }">{{ otp[2] }}</div>
                            <div class="box-input-otp" :class="{ 'box-input-otp-filled': otp[3] }">{{ otp[3] }}</div>
                            <div class="box-input-otp" :class="{ 'box-input-otp-filled': otp[4] }">{{ otp[4] }}</div>
                            <div class="box-input-otp" :class="{ 'box-input-otp-filled': otp[5] }">{{ otp[5] }}</div>
                        </div>
                    </label>
                    <input type="tel" id="input-otp" class="input-otp-dummy" maxlength="6" v-model="otp"
                        @input="onOtpChange()" @blur="onOtpBlur()" @focus="onFocus()" />

                    <!-- <div id="otp_refcode" class="otp-txt">{{`${lblOtp.ref_code}${refcode}`}}</div> -->
                    <div id="otp_time_block">
                        <div id="otp_time_lbl" class="otp-txt" v-if="!isExpired">
                            {{ lblOtp.time_left }} <span id="otp_time">{{ timeHelper.displayTime }} {{ lblOtp.second }}</span>
                        </div>
                        <div id="otp_time_resend" class="ff-bold" @click="resendOtp()" v-if="isExpired">
                            {{ lblOtp.resend_otp }}
                        </div>
                    </div>
                    <div id="otp_error" v-if="error != ''" class="otp-txt error">{{ error }}</div>
                </div>
                <div class="modal-base-footer">
                    <div class="wrapper-confirm-btn">
                        <div class="btn btn-confirm ff-bold" :class="{ 'disable': !isEnableConfirmBtn }"
                            @click="onSubmitOtp()">{{ lblOtp.btn_confirm }}</div>
                    </div>
                    <div class="wrapper-cancel-btn">
                        <div class="btn btn-cancel" @click="cancelOtp()">{{ lblOtp.cancel }}</div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { inject } from "vue";
import Util from "@/helper/Utility.js";
import TimerHelper from "@/helper/TimerHelper.js";

/**
 * ! This file copy form Food Hunt
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "OtpModal",

    components: {

    },
    props: {

        controller: Object,
        modalId: String,
    },
    setup: function () {
        const { lbl } = inject("LocaleStore")

        return {
            lbl
        }
    },
    data: function () {
        return {
            open: false,
            busModal: null,
            lblOtp: {},

            invitationCode: '',
            taxId: '',

            contact_number: '',
            contact_number_msg: '',
            otp: '',
            refcode: '',
            channel: '',
            error: '',

            timeHelper: new TimerHelper(),

            isExpired: false,
            isEnableConfirmBtn: false
        };
    },
    created: function () {
        this.lblOtp = this.lbl.base_otp;
        this.busModal = this.controller.busModal;
        //this.timeHelper.initialTimer(180, ":", true);
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
        this.busModal.on('startOtp', this.startOtp);
        this.busModal.on('cancelOtp', this.cancelOtp);
        this.busModal.on('errorOtp', this.errorOtp);
    },
    methods: {
        onModalHidden: function () {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function () {
            this.otp = '';
            this.showModal();
        },
        showModal: function () {
            document.body.classList.add('not-scroll');
            this.open = true
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false
        },
        //#region otp
        startOtp: async function (config) {
            this.contact_number = config.contact_number;
            if (!this.contact_number) {
                this.contact_number = config.objOTP.contactnumber;
            }
            this.contact_number_msg = Util.stringFormat(this.lblOtp.contact_number_lbl, Util.contactNumberFormat(this.contact_number, '-'));
            this.isExpired = false;
            this.otp = '';
            this.otpType = 'normal';
            this.refcode = config.objOTP.refcode;
            this.otpExpireDate = config.objOTP.expiredate;
            this.error = "";

            this.timeHelper.initialTimerOtp(this.otpExpireDate, ':', false, false);
            this.timeHelper.runTimer(() => {
                this.setTimeout();
            });
            this.showModal();
        },

        cancelOtp: function () {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();

            this.$nextTick(() => {
                this.hide();
                this.controller.sendCallbackCancel();
            });
        },
        errorOtp: function (config) {
            this.error = config.error;
        },
        onOtpChange: function () {
            this.otp = this.otp.replace(/\D/g, '');
            if (!this.isExpired) {
                this.isEnableConfirmBtn = (this.otp && this.otp.length == 6);
            }
            this.error = "";

            // if(Util.isIOS()){
            //     var element = document.getElementById(this.modalId);
            //     element.firstElementChild.classList.add("ios");
            // }
        },

        onOtpBlur: function () {
            if (Util.isIOS()) {
                var element = document.getElementById(this.modalId);
                element.firstElementChild.classList.remove("ios");
            }
        },
        onFocus: function () {
            if (Util.isIOS()) {
                var element = document.getElementById(this.modalId);
                element.firstElementChild.classList.add("ios");
            }
        },
        setTimeout: function () {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isEnableConfirmBtn = false;
            this.isExpired = true;
        },
        onSubmitOtp: function () {
            if (!this.isEnableConfirmBtn) return;

            if (this.validateOtp()) {
                var otpConfig = {
                    contact_number: this.contact_number,
                    otp: this.otp,
                    refcode: this.refcode,
                };
                this.controller.sendCallbackSubmitOtp(otpConfig);
            }
        },
        validateOtp: function () {
            if (this.otp.length != 6) {
                var errorMsg = this.lblOtp.required;
                if (this.otp == '') {
                    errorMsg = this.lblOtp.too_short;
                }

                this.hide();
                this.controller.alertModal.clearText()
                    .setMsg(errorMsg)
                    .show();
                this.controller.alertModal.onHidden(() => {
                    this.showModal();
                });
                return false;
            }

            return true;
        },
        resendOtp: async function () {
            this.cancelOtp();
            this.controller.sendCallbackResendOtp({ tag: this.tag });
        },
        //#endregion otp
    },
}
</script>
<style lang="scss">
@import "../../../../style/modal.scss";

.modal-otp-tranferpoint {
    @extend %modal-base;

    .modal-dialog {
        max-width: 100%;

        .modal-content {
            max-width: 100%;
        }
    }
}
</style>
<style lang="scss" scoped>
@import "../../../../style/base.scss";

.modal-otp-tranferpoint {
    @extend %base-class;
}

.otp-txt {
    text-align: center;
    color: $gray;

    &.error {
        color: $orange;
    }
}

#otp_header {
    font-family: $ff-bold;
    font-size: $px15;
}

// #otp_refcode {
//     color: $black
// }

#otp_please_enter {
    padding-bottom: 15px;
}

#otp_box_wrapper {
    width: 100%;
    margin-top: 30px;
    margin-bottom: 15px;

    .box-input-otp {
        width: 40px;
        height: 65px;
        margin: 5px;
        border: 1px solid $light_gray;
        border-radius: 3px;
        font-size: $px22;
        line-height: 2;
        color: $gray;
        text-align: center;
        cursor: text;
        padding: 13px 0;
    }
}

#otp_time_block {
    // margin-bottom: 30px;

    #otp_time_lbl {
        margin-bottom: 10px;
        font-size: $px15;
        // color: $orange;

        // #otp_time {
        //     // color: $orange;
        // }
    }

    #otp_time_resend {
        // color: $orange;

        text-align: center;
        text-decoration: underline;
    }
}

#otp_close {
    position: absolute;
    top: 15px;
    right: 15px;

    img {
        width: 35px;
    }
}

.modal-base-footer {

    margin-top: 40px;

    .wrapper-cancel-btn {
        width: 100%;
        margin-right: 15px;

        .btn-cancel {
            width: 100%;
            font-family: $ff-bold;
            color: $black;

            border-radius: 40px;
            padding: 20.5px 25px;
            font-size: $px15;

            @include min-desktop {
                font-size: $px18;
            }
        }
    }

    .wrapper-confirm-btn {
        width: 100%;

        .btn-confirm {
            width: 100%;
            font-family: $ff-bold;
            color: white;
            background-color: $black;
            border: 1px solid $black;
            border-radius: 40px;
            padding: 20.5px 25px;
            font-size: $px15;

            @include min-desktop {
                font-size: $px18;
            }

            &.disable {
                color: $light_gray;
                border: 1px solid $bg-disable;
                background-color: $bg-disable;
            }
        }
    }
}



.input-otp-dummy {
    position: absolute;
    top: -20000px;
    left: -20000px;
    opacity: 0;
}
</style>




